/**
 * Generates a random password with letters and numbers
 * @param length - Password length (default: 12)
 * @returns A random password string
 */
export const generateRandomPassword = (length = 12): string => {
  const letters = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const numbers = "0123456789";
  const allChars = letters + numbers;

  let password = "";

  // Ensure at least one letter and one number
  password += letters[Math.floor(Math.random() * letters.length)];
  password += numbers[Math.floor(Math.random() * numbers.length)];

  // Fill the rest with random characters
  for (let i = 2; i < length; i++) {
    password += allChars[Math.floor(Math.random() * allChars.length)];
  }

  // Shuffle the password to randomize positions
  return password
    .split("")
    .sort(() => Math.random() - 0.5)
    .join("");
};
